(function () {
    'use strict';

    const triggers = document.querySelectorAll('.js-accordion-trigger');
    const classOpening = 'js-accordion-target--opening';

    triggers.forEach(function (trigger) {

        trigger.accordionStateOpen = false;

        trigger.addEventListener('click', function (e) {
            const accordionId = trigger.getAttribute('data-accordion-id');
            const targetCont = document.querySelector('.js-accordion-target[data-accordion-id="' + accordionId + '"]');

            if (trigger.accordionStateOpen) {
                trigger.accordionStateOpen = false;
                const closeHeight = 0;
                targetCont.style.height = closeHeight + 'px';
                targetCont.classList.remove(classOpening);
            } else {
                trigger.accordionStateOpen = true;
                const targetContInner = targetCont.querySelector('.js-accordion-targetInner');
                const targetContInnerHeight = targetContInner.clientHeight;
                targetCont.style.height = (targetContInnerHeight) + 'px';
                targetCont.classList.add(classOpening);
            }
        });
    });

    window.addEventListener('resize', function () {
        triggers.forEach(function (trigger) {
            if (trigger.accordionStateOpen) {
                const accordionId = trigger.getAttribute('data-accordion-id');
                const targetCont = document.querySelector('.js-accordion-target[data-accordion-id="' + accordionId + '"]');
                const targetContInner = targetCont.querySelector('.js-accordion-targetInner');
                const targetContInnerHeight = targetContInner.clientHeight;
                targetCont.style.height = (targetContInnerHeight) + 'px';
            }
        });
    });
})();